import { useEffect } from "react";
import { postActivityHeartbeat } from "../services/ApiService";

const isLoggedIn = () => {
  try {
    return !!JSON.parse(localStorage.getItem("accessToken"));
  } catch (e) {
    return false;
  }
};

export default function useActivityHeartbeat() {
  useEffect(() => {
    // only while a user is logged in and this tab is the visible one
    const ping = () => {
      if (!isLoggedIn() || document.visibilityState !== "visible") return;
      postActivityHeartbeat().catch(console.error);
    };

    const timer = setInterval(ping, 10000);
    // ping right away when the user comes back to this tab
    document.addEventListener("visibilitychange", ping);

    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", ping);
    };
  }, []);
}
